import { Button } from '@/components/ui/button';
import { useMe, useResendVerificationEmail } from '@/hooks/use-auth';
import { Mail } from 'lucide-react';

/**
 * Banner amarelo no topo do AppShell quando o user logado ainda NÃO verificou
 * o email. Some quando `me.user.emailVerified === true` ou se ainda não tem
 * sessão (não autenticado).
 *
 * Mostra botão "Reenviar email" que chama POST /auth/resend-verification.
 * Rate limit no backend (3/5min) — toast de feedback no hook.
 */
export function EmailVerificationBanner() {
  const me = useMe();
  const resend = useResendVerificationEmail();

  // Não mostra se: não autenticado, ainda carregando, ou já verificado.
  // emailVerified === undefined (sem o campo do backend) trata como
  // verificado pra evitar mostrar pra users criados antes da feature.
  if (!me.data?.user) return null;
  const verified = me.data.user.emailVerified;
  if (verified !== false) return null;

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm dark:border-amber-900/40 dark:bg-amber-950/30">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-amber-900 dark:text-amber-200">
          <Mail className="h-4 w-4 shrink-0" />
          <span>
            Confirme seu email <strong>{me.data.user.email}</strong> pra ativar todas as features.
            Verifique sua caixa de entrada.
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => resend.mutate()}
          disabled={resend.isPending}
          className="shrink-0"
        >
          {resend.isPending ? 'Enviando…' : 'Reenviar email'}
        </Button>
      </div>
    </div>
  );
}
